export const CACHE_KEY_LIST_NOMENCLATURES_SERVICES_CATEGORY = 'nomenclatures-services-category';
export const CACHE_KEY_NOMENCLATURES_SERVICES_CATEGORY = 'nomenclatures-services-category-one';
export const ROUTE_PATH_NOMENCLATURES_SERVICES_CATEGORY = '/settings/nomenclatures/services-category';
export const TRANSLATION_PREFIX_NOMENCLATURES_SERVICES_CATEGORY = 'nomenclaturesServicesCategory';

